import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "UISandbox" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", null, "UI Sandbox", -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "Toast", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("토스트 호출")
const _hoisted_6 = /*#__PURE__*/_createVNode("h3", null, "Icons dummy", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("h5", null, "size 18", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("h5", null, "size 24", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("h3", null, "Fonts", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "UISandbox__font--regular" }, "노토산스 적용 테스트합니다.", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "UISandbox__font--medium" }, "노토산스 적용 테스트합니다.", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "UISandbox__font--bold" }, "노토산스 적용 테스트합니다.", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", null, "Buttons", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("h5", null, "ButtonRack으로 감싼 버튼, HORIZONTAL", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("기본 버튼")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("아웃라인 버튼")
const _hoisted_20 = /*#__PURE__*/_createVNode("h5", null, "ButtonRack으로 감싼 버튼, VERTICAL", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("기본 버튼")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("아웃라인 버튼")
const _hoisted_23 = /*#__PURE__*/_createVNode("h5", null, "기본 버튼", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("높이 48, 기본 버튼")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("높이 42, 아웃라인 버튼")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("높이 32, 기본 버튼")
const _hoisted_27 = /*#__PURE__*/_createVNode("h5", null, "인라인 버튼", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("버튼")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("버튼")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("버튼")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("버튼")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("버튼")
const _hoisted_33 = /*#__PURE__*/_createVNode("h3", null, "Calendar", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("h3", null, "Tabs", -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_37 = /*#__PURE__*/_createVNode("h5", null, "가운데 정렬형 탭", -1)
const _hoisted_38 = { class: "UISandbox__tabs" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createVNode("h5", null, "가로 스크롤형 탭", -1)
const _hoisted_41 = { class: "UISandbox__tabs" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createVNode("h3", null, "Table", -1)
const _hoisted_44 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("h3", null, "Checkbox", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_47 = /*#__PURE__*/_createVNode("h5", null, "단일 선택만 가능한 체크박스", -1)
const _hoisted_48 = { class: "UISandbox__checkbox" }
const _hoisted_49 = /*#__PURE__*/_createVNode("h5", null, "여러개 선택이 가능한 체크박스", -1)
const _hoisted_50 = { class: "UISandbox__checkbox" }
const _hoisted_51 = /*#__PURE__*/_createVNode("h3", null, "Input", -1)
const _hoisted_52 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_53 = { class: "UISandbox__input" }
const _hoisted_54 = /*#__PURE__*/_createVNode("h3", null, "Accordion", -1)
const _hoisted_55 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("h3", null, "DateRangePicker", -1)
const _hoisted_57 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createVNode("h3", null, "SearchInput", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createVNode("h3", null, "SelectAndSearch", -1)
const _hoisted_62 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createVNode("h3", null, "Check", -1)
const _hoisted_64 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button")
  const _component_Icon = _resolveComponent("Icon")
  const _component_ButtonRack = _resolveComponent("ButtonRack")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Tabs = _resolveComponent("Tabs")
  const _component_Table = _resolveComponent("Table")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Input = _resolveComponent("Input")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_DateRangePicker = _resolveComponent("DateRangePicker")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_SelectAndSearch = _resolveComponent("SelectAndSearch")
  const _component_Check = _resolveComponent("Check")
  const _component_AdaptiveWindowLayout = _resolveComponent("AdaptiveWindowLayout")
  const _directive_line_clamp = _resolveDirective("line-clamp")

  return (_openBlock(), _createBlock(_component_AdaptiveWindowLayout, null, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _createVNode(_component_Button, {
          onClick: _ctx.onToast,
          color: _ctx.ButtonThemeStyle.PRIMARY,
          size: _ctx.ButtonSizeStyle.H50
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick", "color", "size"]),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_18_LOCATION,
          size: 18
        }, null, 8, ["type"]),
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_18_FILTER,
          size: 18
        }, null, 8, ["type"]),
        _hoisted_9,
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_24_HOME,
          size: 24
        }, null, 8, ["type"]),
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_24_LIST,
          size: 24
        }, null, 8, ["type"]),
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_24_QR,
          size: 24
        }, null, 8, ["type"]),
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_24_SEARCH,
          size: 24
        }, null, 8, ["type"]),
        _createVNode(_component_Icon, {
          type: _ctx.IconType.IC_24_USER,
          size: 24
        }, null, 8, ["type"]),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13,
        _hoisted_14,
        _hoisted_15,
        _hoisted_16,
        _hoisted_17,
        _createVNode(_component_ButtonRack, {
          direction: _ctx.ButtonRackDirectionType.HORIZONTAL
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              color: _ctx.ButtonThemeStyle.PRIMARY,
              size: _ctx.ButtonSizeStyle.H50
            }, {
              default: _withCtx(() => [
                _hoisted_18
              ]),
              _: 1
            }, 8, ["color", "size"]),
            _createVNode(_component_Button, {
              color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
              size: _ctx.ButtonSizeStyle.H50
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["color", "size"])
          ]),
          _: 1
        }, 8, ["direction"]),
        _hoisted_20,
        _createVNode(_component_ButtonRack, {
          direction: _ctx.ButtonRackDirectionType.VERTICAL
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, {
              color: _ctx.ButtonThemeStyle.PRIMARY,
              size: _ctx.ButtonSizeStyle.H50
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 1
            }, 8, ["color", "size"]),
            _createVNode(_component_Button, {
              color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
              size: _ctx.ButtonSizeStyle.H50
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            }, 8, ["color", "size"])
          ]),
          _: 1
        }, 8, ["direction"]),
        _hoisted_23,
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.PRIMARY,
          size: _ctx.ButtonSizeStyle.H50
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
          size: _ctx.ButtonSizeStyle.H42
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.PRIMARY,
          size: _ctx.ButtonSizeStyle.H32
        }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _hoisted_27,
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.PRIMARY,
          size: _ctx.ButtonSizeStyle.H50,
          block: false
        }, {
          default: _withCtx(() => [
            _hoisted_28
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
          size: _ctx.ButtonSizeStyle.H50,
          block: false
        }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.PRIMARY,
          size: _ctx.ButtonSizeStyle.H32,
          block: false
        }, {
          default: _withCtx(() => [
            _hoisted_30
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
          size: _ctx.ButtonSizeStyle.H32,
          block: false
        }, {
          default: _withCtx(() => [
            _hoisted_31
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _createVNode(_component_Button, {
          color: _ctx.ButtonThemeStyle.OUTLINE_PRIMARY,
          size: _ctx.ButtonSizeStyle.H32,
          block: false,
          disabled: ""
        }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        }, 8, ["color", "size"]),
        _hoisted_33,
        _hoisted_34,
        _createVNode(_component_Calendar, {
          startDate: _ctx.startDate,
          endDate: _ctx.endDate,
          badges: ['2020-12-11', '2020-12-15'],
          disablePrevButtonFunc: _ctx.disableCalendarPrevButtonFunc
        }, null, 8, ["startDate", "endDate", "disablePrevButtonFunc"]),
        _hoisted_35,
        _hoisted_36,
        _hoisted_37,
        _createVNode("div", _hoisted_38, [
          _createVNode(_component_Tabs, {
            modelValue: _ctx.tabIndex1,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.tabIndex1 = $event)),
            selectedIndex: _ctx.tabIndex1,
            items: _ctx.tabItems1,
            type: _ctx.TabType.CENTER
          }, {
            contents: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabItems1, (item, index1) => {
                return (_openBlock(), _createBlock("div", {
                  key: `tab1-index-${index1}`
                }, [
                  (_ctx.tabIndex1 === index1)
                    ? (_openBlock(), _createBlock("div", _hoisted_39, _toDisplayString(item.content), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1
          }, 8, ["modelValue", "selectedIndex", "items", "type"])
        ]),
        _hoisted_40,
        _createVNode("div", _hoisted_41, [
          _createVNode(_component_Tabs, {
            modelValue: _ctx.tabIndex2,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.tabIndex2 = $event)),
            selectedIndex: _ctx.tabIndex2,
            items: _ctx.tabItems2,
            type: _ctx.TabType.HORIZONTAL_SCROLL
          }, {
            contents: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabItems2, (item, index2) => {
                return (_openBlock(), _createBlock("div", {
                  key: `tab2-index-${index2}`
                }, [
                  (_ctx.tabIndex2 === index2)
                    ? (_openBlock(), _createBlock("div", _hoisted_42, _toDisplayString(item.content), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1
          }, 8, ["modelValue", "selectedIndex", "items", "type"])
        ]),
        _hoisted_43,
        _hoisted_44,
        _createVNode(_component_Table, {
          headers: _ctx.tableData.headers,
          data: _ctx.tableData.data
        }, {
          a: _withCtx((scope) => [
            _withDirectives(_createVNode("div", null, "Custom: " + _toDisplayString(scope.data.a), 513), [
              [_directive_line_clamp, 1, "24"]
            ])
          ]),
          _: 1
        }, 8, ["headers", "data"]),
        _hoisted_45,
        _hoisted_46,
        _hoisted_47,
        _createVNode("h6", null, "선택한 체크박스: " + _toDisplayString(_ctx.checkedNames1), 1),
        _createVNode("div", _hoisted_48, [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.checkedNames1,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.checkedNames1 = $event)),
            size: _ctx.CheckboxSizeType.H42,
            type: _ctx.CheckboxType.SINGLE,
            items: _ctx.checkboxItems1,
            name: "checkedNames1"
          }, null, 8, ["modelValue", "size", "type", "items"])
        ]),
        _hoisted_49,
        _createVNode("h6", null, "선택한 체크박스: " + _toDisplayString(_ctx.checkedNames2), 1),
        _createVNode("div", _hoisted_50, [
          _createVNode(_component_Checkbox, {
            modelValue: _ctx.checkedNames2,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (_ctx.checkedNames2 = $event)),
            size: _ctx.CheckboxSizeType.H32,
            items: _ctx.checkboxItems2,
            type: _ctx.CheckboxType.MULTIPLE,
            name: "checkedNames2"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.data.value), 1 /* TEXT */)
            ]),
            _: 1
          }, 8, ["modelValue", "size", "items", "type"])
        ]),
        _hoisted_51,
        _hoisted_52,
        _createVNode("div", _hoisted_53, [
          _createVNode(_component_Input, {
            modelValue: _ctx.username,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.username = $event)),
            label: "아이디",
            pattern: _ctx.REGEXP_NICKNAME
          }, null, 8, ["modelValue", "pattern"]),
          _createVNode(_component_Input, {
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.password = $event)),
            label: "비밀번호",
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _hoisted_54,
        _createVNode(_component_Accordion, { data: _ctx.accordionData }, {
          default: _withCtx((scope) => [
            _createTextVNode("Custom: " + _toDisplayString(scope), 1 /* TEXT */)
          ]),
          _: 1
        }, 8, ["data"]),
        _hoisted_55,
        _hoisted_56,
        _hoisted_57,
        _createTextVNode(" startDate: " + _toDisplayString(_ctx.startDate) + " endDate: " + _toDisplayString(_ctx.endDate) + " ", 1 /* TEXT */),
        _createVNode(_component_DateRangePicker, {
          startDate: _ctx.startDate,
          "onUpdate:startDate": _cache[7] || (_cache[7] = $event => (_ctx.startDate = $event)),
          endDate: _ctx.endDate,
          "onUpdate:endDate": _cache[8] || (_cache[8] = $event => (_ctx.endDate = $event))
        }, null, 8, ["startDate", "endDate"]),
        _hoisted_58,
        _hoisted_59,
        _hoisted_60,
        _createVNode(_component_SearchInput, {
          keyword: _ctx.keyword,
          "onUpdate:keyword": _cache[9] || (_cache[9] = $event => (_ctx.keyword = $event)),
          placeholder: "입력해주세요"
        }, null, 8, ["keyword"]),
        _hoisted_61,
        _hoisted_62,
        _createVNode(_component_SelectAndSearch, {
          selectable: "",
          items: _ctx.accordionData,
          placeholder: "자전거 번호 6자리 입력",
          maxlength: 10
        }, null, 8, ["items"]),
        _hoisted_63,
        _hoisted_64,
        _createVNode(_component_Check, { checked: "" })
      ])
    ]),
    _: 1
  }))
}